/* RAVEVAM 2026 · Bewegung: Bühne „Ein Tag“, Licht-Felder nur sichtbar animieren, Zeitregler, Tab-Titel.
   07.10.2026: Lampe im Hero und Wisch beim Lichtwechsel auf Florians Wunsch entfernt.
   Ohne Bibliothek. Baut auf rv-licht.js auf (window.rvLicht, Ereignis rv:licht). */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;
  function alle(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function pad(n) { return String(n).padStart(2, '0'); }
  function minJetzt() {
    try {
      var p = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var g = function (t) { return p.find(function (x) { return x.type === t; }).value; };
      return (+g('hour') % 24) * 60 + (+g('minute'));
    } catch (e) { var d = new Date(); return d.getHours() * 60 + d.getMinutes(); }
  }
  function scroller(el) {
    for (var e = el.parentElement; e && e !== document.body; e = e.parentElement) {
      var o = getComputedStyle(e).overflowY;
      if ((o === 'auto' || o === 'scroll') && e.scrollHeight > e.clientHeight) return e;
    }
    return document.scrollingElement || document.documentElement;
  }
  function publish(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }

  /* Licht-Felder laufen nur, solange sie zu sehen sind */
  if (IO && !RM) {
    var ioF = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('rv-sicht', e.isIntersecting); }); }, { rootMargin: '80px' });
    alle('[data-rv-feld]').forEach(function (f) { ioF.observe(f); });
  }

  /* Bühne „Ein Tag. Vier Lichter.“: Scrollen führt durch die Momente. Zwischen zwei Momenten zählt die Uhr weiter,
     das Licht im Feld wandert mit dem Scrollen, die Schrittknöpfe füllen sich; am Übergang wechselt das Feld. */
  alle('[data-rv-tag]').forEach(function (sek) {
    var buehne = sek.querySelector('.rv-buehne');
    var momente = alle('.rv-moment', sek), felder = alle('.rv-buehne > .rv-feld', sek);
    var streifen = alle('.rv-odo-strip', sek), knoepfe = alle('[data-rv-schritt]', sek);
    var n = momente.length, akt = -1, laeuft = false, uhrAlt = '';
    if (!n || !buehne) return;
    var zeiten = momente.map(function (m) { var z = (m.dataset.zeit || '00:00').split(':'); return (+z[0] || 0) * 60 + (+z[1] || 0); });
    function uhr(min) {
      min = Math.round(min) % 1440;
      var z = pad(Math.floor(min / 60)) + pad(min % 60);
      if (z === uhrAlt) return;
      uhrAlt = z;
      streifen.forEach(function (s, k) { s.style.transform = 'translateY(-' + (+(z.charAt(k) || 0)) + 'em)'; });
    }
    function setze(i) {
      if (i === akt) return;
      akt = i;
      var m = momente[i];
      sek.dataset.feld = m.dataset.m;
      felder.forEach(function (f, k) { f.classList.toggle('rv-aktiv', k === i); });
      knoepfe.forEach(function (b, k) { b.setAttribute('aria-pressed', String(k === i)); });
    }
    function lage() {
      var oben = parseFloat(getComputedStyle(buehne).top) || 0;
      var weg = sek.offsetHeight - buehne.offsetHeight;
      var p = weg > 0 ? Math.min(1, Math.max(0, (oben - sek.getBoundingClientRect().top) / weg)) : 0;
      var i = Math.min(n - 1, Math.floor(p * n)), t = Math.min(1, p * n - i);
      setze(i);
      /* Uhr: erste Hälfte steht sie auf dem Moment, dann zählt sie bis zum nächsten */
      var bis = i < n - 1 ? zeiten[i + 1] : zeiten[i];
      if (bis < zeiten[i]) bis += 1440;
      var u = Math.max(0, (t - 0.45) / 0.55);
      uhr(zeiten[i] + (bis - zeiten[i]) * u * u * (3 - 2 * u));
      felder.forEach(function (f, k) { f.style.setProperty('--t', k < i ? 1 : k === i ? t.toFixed(3) : 0); });
      knoepfe.forEach(function (b, k) { b.style.setProperty('--fill', k < i ? 1 : k === i ? t.toFixed(3) : 0); });
    }
    function beimScrollen() { if (laeuft) return; laeuft = true; requestAnimationFrame(function () { laeuft = false; lage(); }); }
    /* Horizon scrollt auf dem Desktop im .page-wrapper statt im Fenster: Scroll-Ereignisse in der Capture-Phase am Dokument fangen beide ab */
    var OPT = { passive: true, capture: true };
    if (IO) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { document.addEventListener('scroll', beimScrollen, OPT); lage(); }
          else document.removeEventListener('scroll', beimScrollen, OPT);
        });
      }).observe(sek);
    } else document.addEventListener('scroll', beimScrollen, OPT);
    window.addEventListener('resize', beimScrollen, { passive: true });
    knoepfe.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.dataset.rvSchritt;
        var oben = parseFloat(getComputedStyle(buehne).top) || 0;
        var weg = sek.offsetHeight - buehne.offsetHeight;
        var sc = scroller(sek);
        var basis = sc === document.scrollingElement ? 0 : sc.getBoundingClientRect().top;
        var start = sc.scrollTop + sek.getBoundingClientRect().top - basis - oben;
        sc.scrollTo({ top: start + weg * (i + 0.5) / n, behavior: RM ? 'auto' : 'smooth' });
      });
    });
    lage();
  });

  /* Zeitregler am 24-Stunden-Verlauf im Fuß; „Jetzt“-Knöpfe (Fuß, Lichtwahl im Seitenkopf) führen zurück zur echten Uhrzeit */
  var reg = document.querySelector('[data-rv-regler]'), jetzt = alle('[data-rv-jetzt]');
  function text(m) { return pad(Math.floor(m / 60)) + ':' + pad(m % 60); }
  function jetztZeigen(an) { jetzt.forEach(function (j) { j.hidden = !an; }); }
  if (reg) {
    reg.value = minJetzt();
    reg.setAttribute('aria-valuetext', 'Köln ' + text(+reg.value));
    reg.addEventListener('input', function () {
      var m = +reg.value;
      if (window.rvLicht) window.rvLicht.zeigeMinute(m);
      reg.setAttribute('aria-valuetext', 'Vorschau ' + text(m));
      jetztZeigen(true);
    });
    reg.addEventListener('change', function () { publish('rv_regler', { minute: +reg.value }); });
  }
  jetzt.forEach(function (j) {
    j.addEventListener('click', function () {
      if (window.rvLicht) window.rvLicht.zeigeMinute(null);
      jetztZeigen(false);
      if (reg) { reg.value = minJetzt(); reg.setAttribute('aria-valuetext', 'Köln ' + text(+reg.value)); }
    });
  });
  document.addEventListener('rv:licht', function (e) {
    var d = e.detail || {};
    if (reg && document.activeElement !== reg && d.min != null) reg.value = d.min;
    jetztZeigen(!!d.vorschau);
  });

  /* Tab im Hintergrund: der Titel wird zur Uhr */
  var titel = document.title;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { titel = document.title; document.title = '● ' + text(minJetzt()) + ' · Noch lange nicht fertig.'; }
    else document.title = titel;
  });
})();
